import React, { useContext, useRef } from 'react';
import { Dropdown } from '@bynder/design-system';

import { InfoContext } from '../../../context';
import { Language } from '../../../types';
import { CSRF } from '../../../helpers/csrf';

export function LanguageItem({ language }: { language: Language }) {
	const { languages } = useContext(InfoContext);

	const formRef = useRef<HTMLFormElement>(null);

	const submitForm = () => {
		formRef.current?.submit();
	};

	return (
		<Dropdown.Item
			onClick={submitForm}
			isChecked={language.locale === languages.selected}
			key={language.locale}
		>
			{language.display_name}
			<form ref={formRef} action="/user/switchlanguage/" method="post" hidden>
				<input name="csrf" value={CSRF} type="hidden" />
				<input name="language" value={language.locale} type="hidden" />
			</form>
		</Dropdown.Item>
	);
}
